module.exports = __webpack_public_path__ + "static/share.9679cf41.png";